import React, {useState, useEffect, Fragment} from 'react';
import {Row, Col, Checkbox, Modal, Upload, Table} from "antd";

import { useSelector, useDispatch } from "react-redux";

import Content from "../../commons/components/content";
import Pagination from "../../commons/components/pagination";
import Input from "../../commons/components/input";
import SearchInput from "../../commons/components/searchInput";
import ButtonIcon from "../../commons/components/buttonIcon";
import Loading from "../../commons/components/loading";
import Permissions from '../../commons/utils/permissions'

import {toast} from "react-toastify";

import ServiceFunction from '../../services/functions'

export default () => {

    const { screens } = useSelector(state => state.userLogin);
    const [permissions] = useState([]);

    const [loadingTable, setLoadingTable] = useState(true);
    
    const [actualPage, setActualPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState("");
    const [selectedFunction, setSelectedFunction] = useState({})

    const [showModalFunction, setShowModalFunction] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const [nomeError, setNomeError] = useState(false);
    const [descricaoError, setDescricaoError] = useState(false);

    const tableColumns = [
        {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Nome',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Descrição',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Ativo',
            dataIndex: 'active',
            key: 'active',
        },
        {
            title: 'Ação',
            key: 'action',
            render: (text, item) => (
                <div style={{ display: 'flex' }}>
                    {(permissions.find(item => item.function_id === Permissions.EDITAR_FUNCAO)) ?
                        <ButtonIcon className="button-edit" text="Editar Função" type="edit" callback={() => handleEditFunction(item)}/>
                        : null
                    }

                    {(permissions.find(item => item.function_id === Permissions.EXCLUIR_FUNCAO)) ?
                        <ButtonIcon className="button-red" text="Excluir Função" type="delete" callback={() => handleDeleteFunction(item)}/>
                        : null
                    }                    
                </div>
            ),
        },
    ];
    const [tableData, setTableData] = useState([])

    useEffect(() => {
        screens.map(screen => {
            if (screen.url === "/functions") {
                screen.functions.map(func => {
                    permissions.push(func)
                })
            }
        });
    }, []);    

    useEffect(()=>{
        if(search === ""){
            getFunctions()
        }
    }, [search]);

    function getFunctionsOrSearch(page) {
        if (search === "") {
            getFunctions(page)
        } else {
            searchFunction(search, page)
        }
    }

    async function getFunctions(page = 1) {
        setLoadingTable(true);
        let response = await ServiceFunction.getAll(page)
        if (response){
            formatTable(response.data.data)
            setActualPage(page);
            setTotalPages(response.data.pagination);
            setLoadingTable(false);
        }
        setShowModalFunction(false)
    }

    async function getFunction(id) {
        setLoadingTable(true);
        let response = await ServiceFunction.getId(id)
        if (response){
            const data = response.data.data[0]
            setSelectedFunction(data);
            setLoadingTable(false);
        }
    }

    async function searchFunction(search) {
        setLoadingTable(true);
        let response = await ServiceFunction.search(search)
        if (response){
            formatTable(response.data.data);
            setActualPage(search);
            setTotalPages(response.data.pagination);            
            setLoadingTable(false);
        }
    }

    function formatTable(data) {
        let array = [];
        data.forEach((item) => {
            item.key = item.id;
            item.active = item.active === true ? "Sim" : "Não";
            array.push(item)
        })
        setTableData(array);
    }

    function handleSearch(e) {
        setSearch(e.target.value);
        if (search.length > 2) {
            searchFunction(search);
        }
    }

    function validateForm() {
        let valid = true;

        if (!selectedFunction.name){
            setNomeError(true);
            toast.error("Informe o nome");
            valid = false;
        }

        if (!selectedFunction.description){
            setDescricaoError(true);
            toast.error("Informe a descrição");
            valid = false;
        }

        return valid;
    }

    function handleSaveModalFunction() {
        setLoadingTable(true);
        if (validateForm()) {
            if (selectedFunction.id) {
                update(selectedFunction)
            } else {
                insert(selectedFunction)
            }
        }
        setLoadingTable(false);
    }

    function handleConfirmDeleteFunction() {
        setLoadingTable(true);
        remove(selectedFunction);
        setShowDeleteModal(false);
        setLoadingTable(false);
    }

    function handleCancelModalFunction() {
        setSelectedFunction({});
        setShowModalFunction(false);

        setNomeError(false);
        setDescricaoError(false);
    }

    function handleCalcelDeleteFunction() {
        setSelectedFunction({});
        setShowDeleteModal(false);
    }

    function handleEditFunction(item) {
        setLoadingTable(true);
        getFunction(item.id);
        setShowModalFunction(true);
        setLoadingTable(false);
    }

    function handleDeleteFunction(item) {
        setLoadingTable(true);
        getFunction(item.id);
        setShowDeleteModal(true);
        setLoadingTable(false);
    }
    
    function handleKeyPress(e){
        if(e.key === "Enter"){
            handleSaveModalFunction();
        }
    }

    function returnConfirmAction() {
        if(search !== ""){
            searchFunction(search);
        }else{
            getFunctions(actualPage)
        }
    }

    async function insert(data) {
        let response = await ServiceFunction.insert(data)
        returnConfirmAction()
    }

    async function update(data) {
        let response = await ServiceFunction.update(data)
        returnConfirmAction()
    }

    async function remove(data) {
        let response = await ServiceFunction.delete(data.id)
        returnConfirmAction()
    }

    const newItemModal = () => (
        <Modal
            title="Cadastro de Funções" visible={showModalFunction} onCancel={handleCancelModalFunction}
            footer={[
                <button key="cancel" onClick={handleCancelModalFunction} className="btn btn-light">Cancelar</button>,
                <button key="confirm" onClick={handleSaveModalFunction} className="btn btn-primary">Salvar</button>
            ]}>
            
            <div className="row">
                <div className="col-6">
                    <div className="form-group">
                        <Input
                            name="name" label="Nome" 
                            value={selectedFunction.name ? selectedFunction.name : ''}
                            hasError={nomeError}
                            onChange={(e) => { setSelectedFunction({ ...selectedFunction, name: e.target.value }); setNomeError(false) }}
                            onKeyPress={(e) => handleKeyPress(e)} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="form-group">
                        <Input
                            name="description" label="Descrição" 
                            value={selectedFunction.description ? selectedFunction.description : ''}
                            hasError={descricaoError}
                            onChange={(e) => { setSelectedFunction({ ...selectedFunction, description: e.target.value }); setDescricaoError(false) }}
                            onKeyPress={(e) => handleKeyPress(e)} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-6">
                    <div className="form-group">
                        <Checkbox
                            inputId="cbAtivo"
                            onChange={(e) => {setSelectedFunction({...selectedFunction, active: e.target.checked})}}
                            checked={selectedFunction.active} 
                        />
                        <label htmlFor="cb_ativo" className="p-checkbox-label" style={{marginLeft: '5px'}}>Ativo</label>
                    </div>
                </div>
            </div> 
        </Modal>
    );

    const deleteRoleModal = () => (
        <Modal visible={showDeleteModal} title="Excluir função"
               onCancel={handleCalcelDeleteFunction} cancelText="Cancelar" onOk={handleConfirmDeleteFunction} okText="Excluir"
               okType="danger">

            <p>Tem certeza que deseja excluir a função <strong>{selectedFunction.name}</strong> ?</p>
            <small><strong><p>Após concluída, essa ação não poderá ser desfeita.</p></strong></small>
        </Modal>
    );

    const renderSearchFunction = () => (
        <div style={{marginBottom: 10}}>
            <SearchInput
                placeholder="Pesquisar..."
                onChange={handleSearch}
                value={search}
                buttonLabel="Limpar" type="close" callback={() => setSearch("")}/>
        </div>
    );

    const renderLoading = () => {
        if (loadingTable) {
            return (
                <div style={{display: "flex", justifyContent: "center"}}>
                    <Loading width={50} height={50}/>
                </div>
            )
        }
    };

    const renderAddFunctionButton = () => {
        if (permissions.find(item => item.function_id === Permissions.CADASTRAR_FUNCAO)) {
            function handleOpenModal() {
                setSelectedFunction({})
                setShowModalFunction(true)
            }

            return (
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <ButtonIcon className="button-green" text="Adicionar Função" type="plus" label="Adicionar"
                        callback={handleOpenModal} />
                </div>
            )
        }
    };

    const renderTable = () => (
        <Fragment>
            <Col span={24}>
                <div style={{ marginBottom: 20 }}>
                    <Table pagination={false} columns={tableColumns} dataSource={tableData} />
                </div>
            </Col>
        </Fragment>
    );

    const renderHeader = () => (
        <Fragment>
            <Col span={8}>
                {renderSearchFunction()}
            </Col>
            <Col span={10}>
                {renderLoading()}
            </Col>
            <Col span={6}>
                {renderAddFunctionButton()}
            </Col>
        </Fragment>
    );

    return (
        <>
            <Content breadcrumb={["Funções"]} minHeight={360}>
                {newItemModal()}
                {deleteRoleModal()}

                <Row type="flex" align="middle">
                    {renderHeader()}
                </Row>

                <Row>
                    {renderTable()}
                </Row>

                <Row type="flex" align="middle">
                    <Col span={12}>
                        <Pagination totalPages={totalPages} actualPage={actualPage} callBack={(page) => getFunctionsOrSearch(page)} />
                    </Col>
                </Row>
            </Content>
        </>
    )
}